import React from "react";

const generateMonth = (year, month) => {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => i + 1);
};

const cardMonth = (year, month, colorResolver, onDayClick, selectedDate) => {
    const days = generateMonth(year, month);
    const formattedMonth = `${year}-${String(month + 1).padStart(2, "0")}`;
    return (
        <div style={{ marginBottom: "20px" }}>
            <h3 style={{ textAlign: "center" }}>📅 {formattedMonth}</h3>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(7, 40px)",
                    gap: "5px",
                    justifyContent: "center",
                }}
            >
                {days.map((day) => {
                    const dateKey = `${formattedMonth}-${String(day).padStart(2, "0")}`;
                    const resolved = colorResolver ? colorResolver(dateKey) : null;
                    const cellColor = resolved && typeof resolved === "object" ? resolved.color : resolved;
                    const cellTitle = resolved && typeof resolved === "object" ? resolved.title : "";
                    const bg = cellColor || (day % 2 === 0 ? "#ccc" : "#ddd");
                    const isSelected = selectedDate && dateKey === selectedDate;
                    return (
                        <div
                            key={dateKey}
                            title={cellTitle}
                            onClick={() => onDayClick && onDayClick(dateKey)}
                            style={{
                                width: "40px",
                                height: "40px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: bg || "#e0e0e0",
                                color: "#000",
                                borderRadius: "5px",
                                cursor: "pointer",
                                border: isSelected ? "2px solid #1f78b4" : "1px solid transparent",
                            }}
                        >
                            {day}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default cardMonth;
